import { Fragment } from 'react';
import { HeaderTop } from './HeaderTop';
import { HeaderMiddle } from './HeaderMiddle';
import { HeaderBottom } from './HeaderBottom';
import { HeaderStiky } from './HeaderSticky';
import { useAppSelector } from '@redux/hooks';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';

import styles from './HeaderMain.module.scss';

const HeaderMain = (): JSX.Element => {
  const { shortHeader } = useAppSelector(state => state.header.data);
  return (
    <Fragment>
      <ErrorBoundaryComponent>
        <HeaderStiky shortHeader={shortHeader} />
      </ErrorBoundaryComponent>
      {!shortHeader && (
        <div className={styles.Wrapper}>
          <HeaderTop />
          <HeaderMiddle />
          <HeaderBottom />
        </div>
      )}
    </Fragment>
  );
};

export default HeaderMain;
